import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFoodListApi } from "./api";

export const getFoodListAction = createAsyncThunk("getFoodList", async (payload) => {
	const res = await getFoodListApi(payload);
	return res.data;
});
